import { FC, PropsWithChildren, createContext } from "react";

import { useGetCampaignsQuery } from "web/features/api/graphQLApiSlice";

import placements from "web/constants/campaignGraphics";

import type { Nullable } from "web/types/Utils";

export const CampaignGraphicsContext = createContext({});

type Placements = typeof placements;

interface ICampaignGraphicsProviderProps {
  categoryId?: Nullable<number>;
  placement: Placements[keyof Placements];
}

const CampaignGraphicsProvider: FC<
  PropsWithChildren<ICampaignGraphicsProviderProps>
> = ({ categoryId, placement, children }) => {
  const { data: campaigns, error, isLoading: loading } = useGetCampaignsQuery({
    categoryId,
    placement,
  });

  const data = {
    graphics: campaigns,
    error,
    loading,
  };

  return (
    <CampaignGraphicsContext.Provider value={{ data }}>
      {children}
    </CampaignGraphicsContext.Provider>
  );
};

export default CampaignGraphicsProvider;
